<template>
  <div class="page-header">
    <div class="left-title">
      <!-- <el-icon><Fold /></el-icon> -->
      <h3>{{ pageTitle }}</h3>
    </div>
    <div class="right-info">
      <div class="dropItem">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <i class="icon el-icon-user-solid"></i>
            <span>{{userInfo.userName}}</span><span>，您好！</span>
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="quitAction">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { loginOut } from '@/api/base';
import LoginUserHelper from '@/utils/LoginUserHelper';
export default {
  data () {
    return {
      userInfo: {
        userName: ''
      }
    }
  },
  props: {
    pageTitle: {
      type: String,
      default: ''
    },  
  },
  mounted () {
    this.userInfo = LoginUserHelper.getUserInfo();
    console.log('this.userInfoxx', this.userInfo)
  },
  methods: {
    quitAction () {
      if (this.$route.path !== '/landingPage') { // 纯后台登录
        const backendAppId = sessionStorage.getItem('backendAppId')
        this.handleLoginOut(backendAppId)
      } else {
        this.handleLoginOut()
      }
    },
    handleLoginOut(appIdData) {
      const userInfoDetail = JSON.parse(localStorage.getItem('userInfoDetail'));
      loginOut({
        appId: appIdData,
        userId: userInfoDetail.userId
      }).then(res => {
        if (res.code === 0) {
          LoginUserHelper.clearLoginData();
          this.$message.success('退出成功');
          this.$router.push('/login');
        } else {
          this.$message.error(res.message)
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  width: 100%;
  height: 80px;
  margin-bottom: 20px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left-title {
    display: flex;
    align-items: center;
    color: #1989fa;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    h3 {
      margin-left: 10px;
    }
  }
}

.dropItem{
  display: flex;
  align-items: center;
  padding-right: 40px;
  font-size: 16px;
  cursor: pointer;
  span{
    font-size: 16px;
  }
  .el-dropdown{
    color: #1989fa;
    font-size: 18px;
    .icon{
      margin-right: 5px;
      vertical-align: middle;
    }
  }
}
@media screen and (max-width: 768px) {
  .page-header {
    height: 60px;
    margin-bottom: 10px;
  }
}
</style>
